import React from 'react';
import { curry } from 'ramda';

const wrapIn = curry((WrapperComponent, WrappedComponent) => props => (
  <WrapperComponent {...props}>
    <WrappedComponent {...props} />
  </WrapperComponent>
));

export default wrapIn;
